import $ from "../../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameE_Dropzone extends PIXI.Container {

  constructor(data, game) {
    super();

    this.game = game;
    this.data = data;

    this.id = this.data.id;
    this.isFilled = false;
    this.answer = null;

    this.position.set(this.data.dropZone.x, this.data.dropZone.y);
    this.originalPosition = new PIXI.Point().copyFrom(this.position); // copy original position to a variable for later

    this.build();
    this.enable();
  }

  build() {
    this.background = new PIXI.Graphics().roundRect(0, 0, this.data.dropZone.width, this.data.dropZone.height, this.data.dropZone.height / 2).fill(0x002277);
    this.background.alpha = 0.4;
    this.addChild(this.background);


    // this.tagValue = tagIndex;

    this.generateAnswer();
    this.buildAnimations();
  }

  enable() {
    this.eventMode = "static";
  }

  getAnswer() {
    return this.answer;
  }

  generateAnswer() {
    if (typeof this.data.answer !== "undefined") {
      let $answer = $(`<p class="i18n answer-tag">
        <span class="en">${this.data.answer.en}</span>
        <span class="fr">${this.data.answer.fr}</span>
      </p>`);


      $answer.css({
        top: this.data.answer.y,
        left: this.data.answer.x,
      })

      this.game.$screenEl.find(".answers-container").append($answer);

      this.answer = $answer;

      gsap.set(this.answer, {
          scale: 0,
        }
      );
    }
  }


  buildAnimations() {
    this.inAnimation = gsap.fromTo(this, {
        pixi: {
          y: this.originalPosition.y + 40,
          alpha: 0,
        },
      }, {
        pixi: {
          y: this.originalPosition.y,
          alpha: 1,
        },
        ease: "power1.out",
        immediateRender: true,
        paused: true,
        duration: 1,
        onComplete: () => {
          this.enable();
        }
      }
    )

  }

  animateIn() {
    if (this.inAnimation) {
      this.inAnimation.play();
    }
  }

  animateDropped() {
    gsap.killTweensOf(this);

    gsap.to(this, {
        pixi: {
          alpha: 0,
        },
        ease: "quad.out",
        duration: 0.25,
      }
    );
  }

  animateAnswer() {
    if (this.answer) {
      gsap.fromTo(this.answer, {
          scale: 0,
        }, {
          scale: 1,
          ease: "back.out(1.2)",
          duration: 0.25,
        }
      );
    }
  }

  animateReset(duration = 0.25) {
    gsap.killTweensOf(this);

    gsap.to(this, {
        pixi: {
          alpha: 1,
        },
        ease: "quad.out",
        duration: duration,
      }
    );

    if (this.answer) {
      gsap.to(this.answer, {
          scale: 0,
          ease: "quad.out",
          duration: duration,
        }
      );
    }
  }

  getBoundingBox() {
    let dropZoneGlobalPos = this.toGlobal(new PIXI.Point(0, 0));

    return {
      x: dropZoneGlobalPos.x,
      y: dropZoneGlobalPos.y,
      width: this.width,
      height: this.height,
      top: dropZoneGlobalPos.y,
      right: dropZoneGlobalPos.x + this.width,
      bottom: dropZoneGlobalPos.y + this.height,
      left: dropZoneGlobalPos.x
    };
  }

  resetState(duration) {
    this.isFilled = false;

    this.animateReset(duration);
  }

  // Reset the states so we can animate in again and start over
  reset() {
    if (this.inAnimation) {
      this.inAnimation.kill();
      this.inAnimation = null;
    }

    this.resetState(0);

    // Rebuild the animations
    this.buildAnimations();
  }


}
